import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    title: 'PDF completo con el sistema RMF',
    desc: 'Claro, directo, profesional.'
  }, {
    title: 'Protocolos por escenario',
    desc: 'Pre‑meeting, inicio de shift, conflicto, error/vergüenza, salida del trabajo.'
  }, {
    title: 'Plantillas para Notes + Google Sheets',
    desc: 'Triage y seguimiento simple.'
  }, {
    title: 'Scripts de mensajes (Spanglish laboral)',
    desc: 'ETA, prioridad, follow‑up, “dame 10”, boundary sin pelear.'
  }, {
    title: 'Troubleshooting real',
    desc: 'Cuando no puedes parar, cuando te da pena, cuando estás demasiado activado.'
  }];
  return <Section className="bg-[#0A0A0A]" data-id="element-103">
      <div className="max-w-4xl mx-auto" data-id="element-104">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-12 text-center" data-id="element-105">
          Qué incluye
        </h2>

        <div className="grid gap-4" data-id="element-106">
          {items.map((item, i) => <div key={i} className="bg-[#111111] border border-gray-800 p-6 rounded-xl flex items-start gap-4 hover:bg-[#161616] transition-colors" data-id="element-107">
              <CheckCircle className="w-6 h-6 text-[#22C55E] shrink-0 mt-1" data-id="element-108" />
              <div data-id="element-109">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-110">
                  {item.title}
                </h3>
                <p className="text-gray-400" data-id="element-111">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}